import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Styled from 'styled-components';

export const Body = Styled.div`
	position: fixed;
	z-index: 1;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: rgba(0,0,0,0.4);

	#modal-header-panel {
		margin: 0px 10px;
		font-weight: bolder;
		line-height: 48px;
		display: flex;
		justify-content: space-between;
	}

	#Popup .modal-content {
		background-color: ${p => p.theme.bgModal};
		margin: auto;
		padding: 20px;
		border: 1px solid ${p => p.theme.border};
		width: 600px;
		border-radius: ${p => p.theme.radius};
		position: absolute;
		left: 50%;
		transform: translate(-50%);
		box-shadow: ${p => p.theme.shadowLg};
		color: ${p => p.theme.text};
	}

	#Popup .closeBtn {
		color: ${p => p.theme.textMuted};
		font-size: 28px;
		font-weight: bold;
		cursor: pointer;
	}

	#Popup .closeBtn:hover,
	#Popup .closeBtn:focus {
		color: ${p => p.theme.text};
	}

	@media screen and (max-width: 600px){
		#Popup .modal-content {
			width: 80%;
		}
	}
`;


let Result = {};
let CurrentModalInfo = {};

export const GetResult = () => {
	return Result;
}

export const SetResult = (Value) => {
	Result = Value;
}

export const ShowModal = (ModalInfo)=> {
	setTimeout(() => {
		let modal = document.getElementById(ModalInfo.ModalName);
		let render = modal.children[0].children[0].children[0].children[2];
		console.log("InitializeModal:" + ModalInfo.ModalName);

		if (modal !== null) {
		modal.style.display = "";
		ReactDOM.render(ModalInfo.Page, render);
		SetResult(undefined);
		CurrentModalInfo[ModalInfo.ModalName] = ModalInfo;
		document.body.style.overflow = 'hidden';
	}
	}, 250);
}

export const ShowPopupModal = (ModalInfo) => {
	setTimeout(() => {
		let modal = document.getElementById(ModalInfo.ModalName);
		let popupModal = modal.children[0].children[0];
		let render = modal.children[0].children[0].children[0].children[2];
		console.log("InitializeModal:" + ModalInfo.ModalName);

		if (modal !== null) {
			modal.style.display = '';
			popupModal.className = 'modalOpen';
			document.body.style.overflow = 'hidden';
			ReactDOM.render(ModalInfo.Page, render);
			SetResult(undefined);
			CurrentModalInfo[ModalInfo.ModalName] = ModalInfo;
		}
	}, 450);
}

export let formClose = (ModalName) => {
	CurrentModalInfo[ModalName].GetResult(GetResult());
	let modal = document.getElementById(CurrentModalInfo[ModalName].ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.render(<div />, render);
	CurrentModalInfo[ModalName] = undefined;
}

export let formCloseDialogResult = (ModalName, isResult) => {
	SetResult({ ...Result, isDialogResult: isResult });
	CurrentModalInfo[ModalName].GetResult(GetResult(isResult));
	let modal = document.getElementById(CurrentModalInfo[ModalName].ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.render(<div />, render);
	CurrentModalInfo[ModalName] = undefined;
}

export let resFormClose = (isResult, ModalInfo) => {
	if (isResult === true) {
		SetResult({ ...Result, isDialogResult: isResult });
		ModalInfo.GetResult(GetResult(isResult));
	}
	let modal = document.getElementById(ModalInfo.ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.render(<div />, render);
}

function Modal(Props) {
	useEffect(() => {
		InitializeComponent();
	}, []);

	const modalRef = useRef();

	let InitializeComponent = () => {
		let modal = document.getElementById(Props.ModalInfo.ModalName);
		document.body.style.overflow = 'auto';
		modal.style.display = "none";
	}

	let formClose = (isResult) => {
		if (isResult === true) {
			SetResult({ ...Result, isDialogResult: isResult });
			Props.ModalInfo.GetResult(GetResult(isResult));
		}
		let modal = document.getElementById(Props.ModalInfo.ModalName);
		let render = modal.children[0].children[0].children[0].children[2];
		modal.style.display = "none";
		document.body.style.overflow = 'auto';
		ReactDOM.render(<div />, render);
	}

	return (
		<Body id={Props.ModalInfo.ModalName}>
			<div style={{ width: '100%' }}>
				<div id = "Popup" className="modal">
					<div className="modal-content">
						<div id="modal-header-panel">
							<label style={{fontSize: '15pt', fontWeight: '1000' }}>{Props.ModalInfo.Title}</label>
							<span className="closeBtn" onClick={() => formClose(false)}>&times;</span>
						</div>
						<hr style={{borderColor: 'currentColor', opacity: 0.2}} />
                        <div></div>
					</div>
				</div>
			</div>
	</Body>
  );
}

export default { Modal, ShowModal, GetResult, SetResult, formClose, formCloseDialogResult, resFormClose, ShowPopupModal };
